import { render } from "./StatusBanner.vue?vue&type=template&id=071adfb9&scoped=true"
import script from "./StatusBanner.vue?vue&type=script&lang=js"
export * from "./StatusBanner.vue?vue&type=script&lang=js"

import "./StatusBanner.vue?vue&type=style&index=0&id=071adfb9&scoped=true&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071adfb9"]])

export default __exports__